import type { ReactNode } from "react";

export function LoadingState({ label = "正在加载赛事资讯…" }: { label?: string }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-lg border border-background-200 bg-background-100 py-16">
      <span className="flex h-12 w-12 items-center justify-center">
        <i className="ri-loader-4-line animate-spin text-3xl text-primary-500"></i>
      </span>
      <p className="text-sm text-foreground-600">{label}</p>
      <div className="flex w-full max-w-md flex-col gap-2.5 px-6">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-3 w-full animate-pulse rounded-full bg-background-300" />
        ))}
      </div>
    </div>
  );
}

export function EmptyState({
  title = "暂无相关内容",
  desc = "当前条件下没有匹配的赛事资讯，换个筛选条件试试。",
  actionLabel,
  onAction,
  icon = "ri-inbox-line",
}: {
  title?: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: string;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-3xl text-foreground-400">
        <i className={icon}></i>
      </span>
      <h3 className="text-base font-bold text-foreground-900">{title}</h3>
      <p className="max-w-md text-sm text-foreground-500">{desc}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-2 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}

export function ErrorState({
  title = "内容加载异常",
  desc = "数据获取时出现了一点问题，请稍后重试。",
  actionLabel = "重新加载",
  onAction,
  children,
}: {
  title?: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-accent-200 bg-accent-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent-100 text-3xl text-accent-700">
        <i className="ri-error-warning-line"></i>
      </span>
      <h3 className="text-base font-bold text-foreground-900">{title}</h3>
      <p className="max-w-md text-sm text-foreground-600">{desc}</p>
      {children}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-2 cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}